import React, { useState } from "react";
import { toast } from "react-hot-toast";

const DocumentDetails = ({ data, update, next, prev }) => {

    const [form, setForm] = useState(data.documents || {});


    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleFile = (e, name) => {

        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "image/jpg"
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error("Only PDF, JPG, PNG allowed");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            toast.error("File must be under 2MB");
            return;
        }

        setForm(prev => ({
            ...prev,
            [name]: file
        }));
    };


    const removeFile = (name) => {
        setForm(prev => ({
            ...prev,
            [name]: null
        }));
    };


    const validate = () => {

        if (!form.addressProof) {
            toast.error("Address proof type required");
            return false;
        }

        if (!form.addressProofNumber) {
            toast.error("Address proof number required");
            return false;
        }

        if (!form.addressProofFile) {
            toast.error("Upload address proof");
            return false;
        }

        if (!form.dobProof) {
            toast.error("DOB proof type required");
            return false;
        }

        if (!form.dobProofNumber) {
            toast.error("DOB proof number required");
            return false;
        }

        if (!form.dobProofFile) {
            toast.error("Upload DOB proof");
            return false;
        }

        return true;
    };


    const handleNext = () => {

        const isValid = validate();

        if (!isValid) return;

        update("documents", form);
        next();
    };


    return (
        <div>

            <h3 className="text-lg font-semibold mb-4">
                Document Details
            </h3>

            <div className="space-y-6">

                {/* Address Proof Row */}
                <div className="grid grid-cols-3 gap-4 items-end">

                    <div>
                        <label className="block mb-1 text-sm font-medium">
                            Address Proof Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="addressProof"
                            value={form.addressProof || ""}
                            className="input w-full"
                            onChange={handleChange}
                        >
                            <option value="">Select Type</option>
                            <option>Aadhaar Card</option>
                            <option>Electricity Bill</option>
                            <option>Bank Statement</option>
                        </select>
                    </div>

                    <div>
                        <label className="block mb-1 text-sm font-medium">
                            Address Proof Number <span className="text-red-500">*</span>
                        </label>
                        <input
                            name="addressProofNumber"
                            value={form.addressProofNumber || ""}
                            placeholder="Enter Number"
                            className="input w-full"
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block mb-1 text-sm font-medium">
                            Upload Address Proof <span className="text-red-500">*</span>
                        </label>

                        <input
                            type="file"
                            className="input w-full"
                            onChange={(e) => handleFile(e, "addressProofFile")}
                        />

                        {form.addressProofFile && (
                            <div className="relative mt-2 border rounded-md p-2 bg-gray-50">

                                <button
                                    type="button"
                                    onClick={() => removeFile("addressProofFile")}
                                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
                                >
                                    ✕
                                </button>

                                <p className="text-sm truncate">
                                    {form.addressProofFile.name}
                                </p>

                            </div>
                        )}

                    </div>

                </div>


                {/* DOB Proof Row */}
                <div className="grid grid-cols-3 gap-4 items-end">

                    <div>
                        <label className="block mb-1 text-sm font-medium">
                            DOB Proof Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="dobProof"
                            value={form.dobProof || ""}
                            className="input w-full"
                            onChange={handleChange}
                        >
                            <option value="">Select Type</option>
                            <option>Birth Certificate</option>
                            <option>10th Certificate</option>
                            <option>Aadhaar Card</option>
                        </select>
                    </div>

                    <div>
                        <label className="block mb-1 text-sm font-medium">
                            DOB Proof Number <span className="text-red-500">*</span>
                        </label>
                        <input
                            name="dobProofNumber"
                            value={form.dobProofNumber || ""}
                            placeholder="Enter Number"
                            className="input w-full"
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block mb-1 text-sm font-medium">
                            Upload DOB Proof <span className="text-red-500">*</span>
                        </label>

                        <input
                            type="file"
                            className="input w-full"
                            onChange={(e) => handleFile(e, "dobProofFile")}
                        />

                        {form.dobProofFile && (
                            <div className="relative mt-2 border rounded-md p-2 bg-gray-50">

                                <button
                                    type="button"
                                    onClick={() => removeFile("dobProofFile")}
                                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
                                >
                                    ✕
                                </button>

                                <p className="text-sm truncate">
                                    {form.dobProofFile.name}
                                </p>

                            </div>
                        )}

                    </div>

                </div>

            </div>


            <div className="mt-6 flex justify-between">

                <button
                    onClick={prev}
                    className="btn-secondary"
                >
                    Back
                </button>

                <button
                    onClick={handleNext}
                    className="btn-primary"
                >
                    Next
                </button>

            </div>

        </div>
    );
};

export default DocumentDetails;